<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">예약취소내역</span>
            <span class="txt">레슨권에 대한 예약, 취소 내역을 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-1"
                        v-model="searchDateType"
                        name="radio-day"
                        type="radio"
                        value="S"
                        @click="onReserveList"
                    />
                    <label for="radio-day-1">예약일자</label>
                </div>
                <div class="com-radio">
                    <input
                        id="radio-day-2"
                        v-model="searchDateType"
                        name="radio-day"
                        type="radio"
                        value="L"
                        @click="onReserveList"
                    />
                    <label for="radio-day-2">수업일자</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="회원명 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['강사명', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    @update:set="(val) => (teacherStaff = val)"
                ></select-form>
                <select-form
                    :select-data="[
                        '예약상태',
                        '예약',
                        '예약대기',
                        '취소',
                        '변경예약',
                        '대기취소',
                        '변경취소',
                        '예약대기취소',
                    ]"
                    :select-value="['', 'RR', 'RW', 'RC', 'WC', 'CR', 'CC', 'WC']"
                    @update:set="(val) => (status = val)"
                ></select-form>
                <select-form
                    :select-data="['디바이스', '관리자웹', '관리자앱', '회원앱','자동예약']"
                    :select-value="['', 'AW', 'AA', 'CA', 'AU']"
                    @update:set="(val) => (device = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 250px" />
                    <col style="width: 120px" />
                    <col style="width: 370px" />
                    <col style="width: 200px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 140px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <!-- 솔트 타입에 값이 ''이면 솔팅없음(올림차순기능이 없다.), 이외의 값이 들어가면, 내림차순..  -->
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'createDate'),
                                        onReserveList()
                                "
                            >
                                예약시간
                            </button>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'lessonName'),
                                        onReserveList()
                                "
                            >
                                이용권명
                            </button>
                        </th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'lessonDate'),
                                        onReserveList()
                                "
                            >
                                수업일자
                            </button>
                        </th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'centerStaffname'),
                                        onReserveList()
                                "
                            >
                                강사명
                            </button>
                        </th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'attendanceStatus'),
                                        onReserveList()
                                "
                            >
                                상태
                            </button>
                        </th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'attendanceDevice'),
                                        onReserveList()
                                "
                            >
                                디바이스
                            </button>
                        </th>
                        <th>
                            <button
                                @click="
                                    (sortType = sortType == 'ASC' ? 'DESC' : 'ASC'),
                                        (sortColumn = 'reservationName'),
                                        onReserveList()
                                "
                            >
                                예약주체
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r, index) in reserveList" :key="index">
                        <td>{{ convertTime2(r.cth_resv_dt) }}</td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${r.ccp_center_id}`,
                                    query: { customerId: r.ccp_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ r.cust_namee }}
                            </router-link>
                        </td>
                        <td class="left">
                            <span v-if="r.cp_ticket_type_cd == 'P'" class="ico type-1">[개인]</span>
                            <span v-if="r.cp_ticket_type_cd == 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="r.cp_ticket_type_cd == 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="r.cp_ticket_type_cd == 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="r.cp_ticket_type_cd == 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="r.cp_ticket_type_cd == 'O'" class="ico type-6">[OT]</span>
                            <span v-if="r.cp_ticket_type_cd == 'S'" class="ico type-8">[운동복]</span>
                            <router-link
                                :to="{
                                    path: `/madmin/member/account/${r.cp_center_id}`,
                                    query: { customerId: r.ccp_center_cust_id, contractId: r.ccp_center_contract_id },
                                }"
                                class="link"
                            >
                                {{ r.cp_namee }}
                            </router-link>
                        </td>
                        <td>{{ r.cth_less_dt | formatDate("YYYY-MM-DD (ddd) HH:mm") }}</td>
                        <td>{{ r.cs_namee }}</td>
                        <td>
                            <span
                                :class="{
                                    red:
                                        r.cth_resv_status_cd === 'RC' ||
                                        r.cth_resv_status_cd === 'CC' ||
                                        r.cth_resv_status_cd === 'WC',
                                }"
                            >
                                {{ convertStatusType(r.cth_resv_status_cd) }}
                            </span>
                        </td>
                        <td>{{ convertDeviceType(r.cth_resv_dev_cd) }}</td>
                        <td>{{ r.upd_namee }}</td>
                    </tr>
                    <tr v-if="reserveList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'HistoryReserve',
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onReserveList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        teacherStaff(newValue) {
            this.teacherStaff = newValue;
            this.onReserveList();
        },
        status(newValue) {
            this.status = newValue;
            this.onReserveList();
        },
        device(newValue) {
            this.device = newValue;
            this.onReserveList();
        },
    },
    data() {
        return {
            reserveList: [], // 리스트 관련

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            searchStr: '', // 이름
            searchPeriod: '', // 검색 기간 설정

            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            searchDateType: 'S', // 기본값 S
            teacherList: [], // 강사 직원
            teacherValueList: [],

            teacherStaff: '',
            device: '',
            status: '',
            // 솔팅 ...
            sortType: 'ASC',
            sortColumn: '',
        };
    },
    mounted() {
        this.init();
    },
    activated() {
        this.onReserveList(); // 예약 리스트 확인
    },
    methods: {
        // 초기화
        async init() {
            try {
                await this.onFetchTeachers(); // 강사명 조회 값 넣기.
            } catch (error) {
                console.error(error);
            }
        },
        async onReserveList() {
            try {
                const { data } = await this.getReserveList();
                this.reserveList = data.items;
                this.setPageParams(data);
            } catch (error) {
                console.error(error);
            }
        },
        getReserveList() {
            // 스웨거 검색: 회원별 센터강의 예약/취소 목록조회(페이징)
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/reservation/all`, {
                params: {
                    sortType: this.sortType,
                    sortColumn: this.sortColumn,
                    searchDateType: this.searchDateType,
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    centerStaffId: this.teacherStaff,
                    centerCustomerName: this.searchStr,
                    reservationStatus: this.status,
                    attendanceDevice: this.device,
                    ...this.pagingInfo,
                },
            });
        },
        convertStatusType(type) {
            if (type === 'RR') {
                return '예약';
            } else if (type === 'RW') {
                return '예약대기';
            } else if (type === 'RC') {
                return '취소';
            } else if (type === 'CR') {
                return '변경예약';
            } else if (type === 'CC') {
                return '변경취소';
            } else if (type === 'WC') {
                return '예약대기취소';
            }
        },
        convertDeviceType(type) {
            if (type === 'AW') {
                return '관리자WEB';
            } else if (type === 'AA') {
                return '관리자APP';
            } else if (type === 'CA') {
                return '회원APP';
            } else if (type === 'TU') {
                return '터치모니터';
            }else if (type === 'AU') {
                return  '자동예약';
            }
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onReserveList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onReserveList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.searchType = '';
            this.searchPeriod = '';
            this.teacherStaff = '';
            this.status = '';
            this.device = '';
            this.onReserveList();
            EventBus.$emit('event:initList', 'init');
        },
        // 페이징 기본값
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            return startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onReserveList();
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onReserveList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onReserveList();
        },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        convertTime(date, time) {
            const hour = time.slice(0, 2);
            const minute = time.slice(3, 2);
            return moment(date).hour(Number(hour)).minute(Number(minute)).locale('ko').format('YYYY-MM-DD(ddd) HH:mm');
        },
        convertTime2(time) {
            return moment(time).locale('ko').format('YYYY.MM.DD HH:mm:ss');
        },
        getReservationId(r) {
            //              예약자 타입,        예약자 이름?, 예약자고객이름,  수업강사명,   고객명..
            // console.log(r.cth_resv_type_cd, r.rcs_namee, r.rcust_namee, r.cs_namee, r.cust_namee);
            console.log(r.cth_resv_id);
            let answer = '';
            if (r.cth_resv_type_cd === 'S') {
                if( r.cth_resv_dev_cd === 'CA' ){
                    answer = r.cust_namee;
                }else {
                    answer = r.rcs_namee;
                }
            } else if (r.cth_resv_type_cd === 'C') {
                answer = r.rcust_namee;
            }
            if (r.cth_resv_id === null) {
                answer = '자동';
            }
            return answer;
        },
    },
};
</script>
<style lang="scss"></style>
